import { getEconomicCalendarSyncYears } from "./sync-years";

/** All yyyy-MM keys for the rolling sync year window. */
export function getEconomicCalendarSyncMonthKeys(
  reference = new Date()
): string[] {
  const years = getEconomicCalendarSyncYears(reference);
  const keys: string[] = [];
  for (const year of years) {
    for (let month = 1; month <= 12; month++) {
      keys.push(`${year}-${String(month).padStart(2, "0")}`);
    }
  }
  return keys;
}

export function monthKeyFromEventDate(date: string): string {
  const raw = date.includes("T") ? date.split("T")[0]! : date.slice(0, 10);
  return raw.slice(0, 7);
}
